// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"637":"order","826":"index"}[chunkId] || chunkId) + "." + {"637":"90321963","826":"12e9968e","972":"7008ade3"}[chunkId] + ".js";
};